module.exports = __webpack_public_path__ + "static/1-2ab6ee06b47e6cb7424dd49ae54f4fd8.png";